// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getPublicIntegrationKey } from './get-public-integration-key';

export const DEMONSTRATION_MERCHANT_PUBLIC_KEY = '1231000';

export function isDemonstrationMerchant(merchant: Merchant): boolean {
  const publicKey = getPublicIntegrationKey(merchant);
  if (publicKey == null) {
    return false;
  }
  return publicKey.replace(/^pk_/, '') === DEMONSTRATION_MERCHANT_PUBLIC_KEY;
}
